import get from 'lodash/get';
import { NOT_ENROLLED } from '@atlassian/jira-common-util-get-experiment-group';
import { getAllFeatureFlags } from '@atlassian/jira-feature-flagging-using-meta';
import type { FeatureFlagValue } from '../../types';

export const getFeatureFlagValue = (featureFlagKey: string): FeatureFlagValue => {
	const featureFlags = getAllFeatureFlags();
	const flagValue = get(featureFlags, [featureFlagKey]);
	if (typeof flagValue === 'undefined') {
		return {
			value: NOT_ENROLLED,
			explanation: {
				ruleId: null,
				kind: 'INELIGIBLE',
			},
		};
	}
	// @ts-expect-error - TS2741 - Property 'explanation' is missing in type '{ value: FeatureFlagValue; }' but required in type 'FeatureFlagValue'.
	return flagValue;
};
